import { Component, Input, OnInit } from '@angular/core';
import { BlobUrlManager } from 'apps/idl/src/modules/filesystem/BlobUrlManager';
import { IPatient } from '../../../../../modules/patients/model/IPatient';
import { DrawerPopoverService } from '../../services/drawer-popover.service';

@Component({
  selector: 'di-choix-phone-call',
  templateUrl: './choix-phone-call.component.html',
  styleUrls: ['./choix-phone-call.component.scss'],
})
export class choixPhoneCallComponent implements OnInit {

	isLargeScreen: boolean = false;
	private readonly moBlobUrlManager = new BlobUrlManager();

	@Input() patient: IPatient

  constructor(private svcPopoverDrawer : DrawerPopoverService) {}

  ngOnInit(): void {
	
  }


	public call(number :string){
		this.svcPopoverDrawer.close();
		window.location.href = `tel:${this.patient.phone}`;
	}
  

}
